import client from '@/http'

const load = ({ commit, state }, params) => {
  if (params.withTrashed) {
    commit('SET_DATASETS', [])
  }

  if (!params.noReset) commit('SET_LOADING', 1)

  client.get(
    `/datasets/table/${params.tableId}/bundle/${params.bundleId}/columns/${params.columnIds}`
  ).then((res) => {
    if (res.data !== 'Rebuilding cache') {
      commit('SET_LOADING', 2)

      if (state.refreshing === 1) {
        commit('SET_REFRESHING', 2)
      }

      commit('SET_DATASETS', res.data)
      commit('SET_LOADING', 0)
      setTimeout(() => commit('SET_REFRESHING', 0), 3000)
    }
  }).catch((e) => {
    console.error(e)
  })
}

const save = (context, params) => {
  if (params.id) {
    const payload = {
      datasets: [params.id],
      table_id: params.tableId,
      bundle_id: params.bundleId,
      changes: params.columnValues.map(column => {
        return {
          columnId: column.column_id,
          value: column.value_id
        }
      })
    }

    client.post(
      `datasets/bulk-edit`, payload
    ).then(
      () => {}
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      `/datasets`, params
    ).then(
      () => {}
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const restore = (context, params) => {
  client.put(
    `datasets/restore/${params.datasetId}/${params.tableId}`
  ).then(
    () => {
      context.commit('RESTORE_DATASET', params.datasetId)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const remove = (context, datasetId) => {
  client.delete(
    `/datasets/${datasetId}`
  ).then(
    () => {}
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const refresh = (context, params) => {
  context.commit('SET_REFRESHING', 1)

  client.get(
    `datasets/refresh/${params.tableId}/${params.bundleId}`
  ).then(
    () => {}
  ).catch(
    (e) => {
      console.error(e)
    }
  )
}

const massRemove = (context, data) => {
  client.post(
    '/datasets/bulk-delete', data
  ).then(
    () => {
      data.removables.forEach(() => {})
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const submitImport = (context, params) => {
  client.post(
    'datasets/import', params
  ).then(
    res => {
      if (params.dryRun) {
        context.commit('SET_IMPORT', res.data)
      }
    }
  ).catch(
    e => {
      console.error(e)
    }
  )
}

export default {
  load,
  save,
  remove,
  restore,
  refresh,
  massRemove,
  submitImport
}
